import React from "react";

import { Header } from "../header";
import UserAgentUtil from "shared/utils/useAgent";
import { isCurrentPathWhitelisted } from "shared/utils";
import { LogoOnlyHeaderForMobile } from "../header/LogoOnlyHeader";
import { LOGO_ONLY_HEADER_ROUTES_FOR_MOBILE } from "shared/utils/constants";

function HeaderWrapper() {
  const showLogoOnlyHeader = React.useMemo(
    () => UserAgentUtil.isMobileDevice() && isCurrentPathWhitelisted(LOGO_ONLY_HEADER_ROUTES_FOR_MOBILE),
    []
  );

  return showLogoOnlyHeader ? <LogoOnlyHeaderForMobile /> : <Header />;
}

export default HeaderWrapper;
